import React, { Component } from "react";
import TopHeader from "../template/TopHeader";
import { productAction } from "../../_actions/product.action";
import { connect } from "react-redux";
import DeleteConfirmationPopup from "../common/DeleteConfirmationPopup";

class DeleteProduct extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDeleteModal: true
    };
  }

  handleCloseModal = () => {
    const { history } = this.props;
    history.push("/product");
  };

  deleteProduct = () => {
    const { history } = this.props;
    const productId = this.props?.location?.state?.productId;
    if (productId) {
      this.props.dispatch(productAction.deleteProduct({productId: productId}))
        .then((response) => {
          history.push("/product");
        })
        .catch((error) => {
          console.log("error", error);
        });
    }
  };

  render() {
    const deleteProductMsg = {
      heading: "Delete Product",
      discription: "Are you sure you want to delete this product? This action cannot be undone.",
      btntext1: "Cancel",
      btntext2: "Delete"
    };

    return (
      <div>
        <div className="h_n">
          <TopHeader title="Edit Product" {...this.props} />
          <div className="product_div">
            <DeleteConfirmationPopup
              show={this.state.showDeleteModal}
              onHide={this.handleCloseModal}
              itemType="product"
              itemId={this.props?.location?.state?.productId}
              itemName="this product"
              refreshList={() => {}}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(DeleteProduct);
